<template lang="pug">
  div.my-1.d-flex.mt-4
    product-card-display.mr-3(:parentProduct="parentProduct")
    v-spacer
    template(v-if="parentProduct.has_variants")
      div.mt-3(style="min-width: 80px")
        div.d-flex.flex-column.align-end
          v-btn(x-small text height="30" :loading="isFetching" @click="expandVariants")
            .button-Aa-small.info500--text {{ parentProduct.view ? 'Hide' : 'View' }} variants
          eva-icon.mr-3.mt-3(:name="parentProduct.view ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline'" width="16" height="16" :fill="$vuetify.theme.themes[$theme].primary500")
    template(v-else)
      v-form(ref="form")
        product-tiers-input(:tiers="tiers" :focused="focused" :parentNoValues="parentNoValues" :valueChanged="valueChanged" @unapply="unapply")
</template>

<script>
import clone from 'just-clone'
import ProductCardDisplay from '@/components/resellers/productTiers/ProductCardDisplay.vue'
import ProductTiersInput from '@/components/resellers/productTiers/ProductTiersInput.vue'

export default {
  name: 'ProductTierIndividualItem',
  components: {
    ProductCardDisplay,
    ProductTiersInput
  },
  props: {
    focused: {
      type: Boolean
    },
    edited: {
      type: Object,
      default: null
    },
    parentProduct: {
      type: Object,
      required: true
    }
  },
  data(v) {
    return {
      rules: {
        required_or_null: [v => !v || v >= 0 || 'Positive value only']
      },
      tiers: v.parentProduct.tiers ? clone(v.parentProduct.tiers) : null,
      valueChanged: false,
      isFetching: false,
      filterParams: {
        expand: 'variants'
      }
    }
  },
  computed: {
    parentNoValues() {
      return this.parentProduct.tiers ? this.parentProduct.tiers.every(tier => !tier.commission_value) : false
    },
    areEmpty() {
      return this.tiers ? this.tiers.every(value => !value.commission_value || value.commission_value === '') : false
    },
    fetchUrl() {
      return `/product_tiers/${this.parentProduct.id}/`
    }
  },
  mounted() {
    if (this.edited) {
      this.tiers = [...this.edited.tiers]
    }
  },
  watch: {
    tiers: {
      deep: true,
      handler(values) {
        if (!this.$refs.form.validate()) {
          this.$emit('removeValue', { id: this.parentProduct.id })
          this.valueChanged = false
          return
        }
        if (this.areEmpty && this.parentNoValues) {
          this.$emit('removeValue', { id: this.parentProduct.id })
          this.tiers.forEach(tier => {
            tier.commission_value = null
          })
          this.valueChanged = false
        } else {
          values = values.map(value => {
            // Populate data to zero
            if (!value.commission_value || value.commission_value === '') {
              value.commission_value = 0
            }
            return value
          })
          this.$emit('editValue', { id: this.parentProduct.id, tiers: values })
          this.valueChanged = true
        }
      }
    }
  },
  methods: {
    unapply() {
      this.tiers = this.parentProduct.tiers.map(tier => {
        return {
          ...tier,
          commission_value: null
        }
      })
      this.$emit('editValue', { id: this.parentProduct.id, tiers: this.tiers })
      this.valueChanged = true
    },
    expandVariants() {
      if (this.parentProduct.variantExpanded) {
        this.parentProduct.view = !this.parentProduct.view
        return
      }
      // Fetch data
      this.isFetching = true
      return this.axios
        .get(this.fetchUrl, { params: this.filterParams })
        .then(resp => {
          const allowedProperties = ['id', 'name', 'display_name', 'price', 'image', 'has_variants', 'tiers']
          const variants = resp.data.variants.map(variant => {
            return this.$options.filters.filterAllowedObjectProperties(variant.product, allowedProperties)
          })
          this.$emit('updateVariants', { parentProduct: this.parentProduct, variants })
          this.parentProduct.view = true
          this.isFetching = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.value-changed {
  border: 1px solid var(--v-success500);
}
</style>